"use client";

import type { PropsWithChildren } from "react";
import { useEffect, useState } from "react";

interface DelayedRenderProps {
  delay: number;
}

// eslint-disable-next-line @typescript-eslint/promise-function-async -- it's ok
export function DelayedRender({ children, delay }: PropsWithChildren<DelayedRenderProps>) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsReady(true);
    }, delay);

    return () => clearTimeout(timeout);
  }, [delay]);

  return isReady ? children : null;
}
